"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentageChange = exports.list_to_tree = exports.buildTree = exports.GetDeepContent = void 0;
var lodash_1 = __importDefault(require("lodash"));
var enums_1 = require("../enums");
/**
 * Selects a value from a Json object that could be as a value prop
 * ```
 * var s ={foo:{bar:"test"}}
 * GetDeepContent(s, "foo.bar");
 *
 * // returns "test"
 *
 * ```
 * @param obj Json object to be traversed for the value
 * @param selector The path to the value separated by "."
 */
var GetDeepContent = function (obj, selector) {
    var undef;
    var tree = selector.split(".");
    while (obj && tree[0])
        obj = obj[tree.shift()] || undef;
    return obj;
};
exports.GetDeepContent = GetDeepContent;
//////////// BUILD TREE STRUCTURE JSON ///////
function buildTree(data, parent, selector, depth) {
    if (selector === void 0) { selector = "id"; }
    if (depth === void 0) { depth = 0; }
    var result = [];
    var defaultParent = {};
    defaultParent[selector] = "";
    parent = parent ? parent : defaultParent;
    var children = lodash_1.default.filter(data, function (value) {
        return value.parent === parent[selector];
    });
    if (!lodash_1.default.isEmpty(children)) {
        lodash_1.default.each(children, function (child) {
            child.depth = depth;
            if (child != null) {
                var ownChildren = buildTree(data, child, selector, depth + 1);
                if (!lodash_1.default.isEmpty(ownChildren)) {
                    child.children = ownChildren;
                }
                result.push(child);
            }
        });
    }
    return result;
}
exports.buildTree = buildTree;
function list_to_tree(list) {
    var map = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i; // initialize the map
        list[i].children = []; // initialize the children
    }
    for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== "0") {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parentId]].children.push(node);
        }
        else {
            roots.push(node);
        }
    }
    return roots;
}
exports.list_to_tree = list_to_tree;
//////////// COMPARISON HELPERS FOR INSIGHTS ///////
var percentageChange = function (prevValue, newValue) {
    var percentageChange = ((newValue - prevValue) / prevValue) * 100;
    if (percentageChange > 0) {
        return {
            type: enums_1.Enums.ChangeType.POSITIVE,
            value: percentageChange === Infinity ? 100 : percentageChange
        };
    }
    else if (percentageChange < 0) {
        return {
            type: enums_1.Enums.ChangeType.NEGATIVE,
            value: percentageChange
        };
    }
    else {
        return {
            type: enums_1.Enums.ChangeType.NEUTRAL,
            value: 0
        };
    }
};
exports.percentageChange = percentageChange;
